export default {
  name: 'RosterStudentForm',
  props: ['project', 'errors', 'form']
};